import React from 'react'
import { Component } from 'react';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { AuthenticationResultStatus } from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';

export class Register extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            confirmPassword: '',
            message: undefined,
            loading: false
        };
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true, message: undefined });

        if (this.state.password !== this.state.confirmPassword) {
            this.setState({ message: 'L\u00f6senorden m\u00e5ste matcha varandra', loading: false });
            return;
        }

        const result = await authService.register(
            this.state.email,
            this.state.password,
            this.state.confirmPassword
        );

        if (result.status === AuthenticationResultStatus.Success) {
            window.location.replace('/Medlem');
        } else {
            this.setState({ message: result.message, loading: false });
        }
    }

    render() {
        const { message, loading } = this.state;

        return (
            <div>
                <h2>Bli medlem</h2>
                <p>Bli medlem hos oss genom att fylla i formul&auml;ret nedan.</p>
                <div className="row">
                    <div className="col-md-4">
                        <form onSubmit={this.handleSubmit}>
                            {message && <div className="text-danger mb-3">{message}</div>}
                            <div className="form-group mb-3">
                                <label htmlFor="email">E-post adress</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={this.state.email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="password">L&ouml;senord</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    value={this.state.password}
                                    onChange={(e) => this.setState({ password: e.target.value })}
                                    required
                                    minLength="6"
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="confirmPassword">Bekr&auml;fta l&ouml;senordet</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="confirmPassword"
                                    value={this.state.confirmPassword}
                                    onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                                    required
                                    minLength="6"
                                />
                            </div>
                            <div className="form-group mb-3">
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? 'Registrerar...' : 'Skicka!'}
                                </button>
                            </div>
                            <div className="form-group mb-3">
                                <p className="text-muted" style={{ fontSize: '0.9em' }}>
                                    Genom att registrera dig godk&auml;nner du v&aring;r <Link to="/Integritetspolicy">integritetspolicy</Link>.
                                </p>
                            </div>
                            <div className="form-group">
                                <p>
                                    Redan medlem? <Link to={ApplicationPaths.Login}>Logga in</Link>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
